import React from 'react';
import PropTypes from 'prop-types';
import Rainbow from 'rainbowvis.js';

import { FeatureGroup, Polygon, Tooltip } from 'react-leaflet';

import _ from 'lodash';
import ReadingsHelpers from 'utils/ReadingsHelpers';

import '../Leaflet.css';

const rainbow = new Rainbow();
const rainbow2 = new Rainbow();

rainbow.setSpectrum('red', 'orange', 'yellow', 'green', 'yellow', 'orange', 'red');
rainbow2.setSpectrum('white', 'lightblue', 'royalblue', 'blue', 'blue', 'darkblue', 'midnightblue');

const getColor = (value, min, max, curve, heatMap) => {
  let factor = 100;
  if (curve === 0) {
    factor = 50;
  } else if (curve === 2) {
    factor = 50;
  }
  let d = ((value - min) / (max - min)) * factor; // eslint-disable-line
  if (d > 100) {
    d = 100;
  } else if (d < 0) {
    d = 0;
  }
  if (curve === 2) {
    d += 50;
  }
  return heatMap ? `#${rainbow.colourAt(d)}` : `#${rainbow2.colourAt(d)}`;
};

export default function ReadingLayers({ d3Polygons, activeReading, opacity, heatMap }) {
  const isoband = [];
  const polygonMouseOver = (event) => {
    const layer = event.target;
    layer.setStyle({
      fillOpacity: opacity * 2,
    });
  };
  const polygonMouseOut = (event) => {
    const layer = event.target;
    layer.setStyle({
      fillOpacity: opacity,
    });
  };
  const readingProps = ReadingsHelpers.readings[activeReading];

  if (d3Polygons && readingProps) {
    _.map(d3Polygons, (poly) => {
      if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        console.log('Getting Color for ', activeReading, poly.value, readingProps);
      }
      // const value = Number(ReadingsHelpers.displayReading(activeReading, poly.value, false, false));
      const color = getColor(poly.value, readingProps.minVal, readingProps.maxVal, readingProps.curve, heatMap);
      //        _.forEach(poly.polygons, subPoly => {
      const rand = Math.random();
      const polyg = (
        <Polygon
          onMouseover={polygonMouseOver}
          onFocus={polygonMouseOver}
          onMouseout={polygonMouseOut}
          onBlur={polygonMouseOut}
          key={rand}
          id={rand}
          positions={poly.polygons}
          color={color}
          stroke={false}
          fillColor={color}
          fillOpacity={opacity}
        >
          <Tooltip sticky>
            <span> {ReadingsHelpers.displayReading(activeReading, poly.value, '', true, true)} </span>
          </Tooltip>
        </Polygon>
      );
      isoband.push(polyg);
      //        })
    });
  }

  return <FeatureGroup>{isoband}</FeatureGroup>;
}

ReadingLayers.propTypes = {
  d3Polygons: PropTypes.array,
  activeReading: PropTypes.string,
  opacity: PropTypes.number,
  heatMap: PropTypes.bool,
};

ReadingLayers.defaultProps = {
  // organization: undefined,
  d3Polygons: [],
  activeReading: undefined,
  opacity: 0.15,
  heatMap: true,
};
